/* 🤖 this file was generated by svg-to-ts*/
export const icoLocationFilled: {
  name: 'location-filled';
  data: string;
} = {
  name: 'location-filled',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2a7 7 0 017 7c0 1.056-.235 2.08-.647 2.934-.892 2.379-2.734 5.58-5.53 9.634a1 1 0 01-1.646 0l-.606-.887-.597-.894c-2.128-3.22-3.565-5.822-4.294-7.774A7 7 0 0112 2zm0 5a2 2 0 100 4 2 2 0 000-4z" fill="#909090"/></svg>`
};
